import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (credentials, { rejectWithValue }) => {
    try {
      // محاكاة طلب تسجيل دخول يستغرق ثانية واحدة
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // محاكاة بيانات المستخدم
      if (credentials.email === 'user@sanad.com' && credentials.password === 'password123') {
        return {
          id: 1,
          name: 'محمد أحمد',
          email: credentials.email,
          token: 'fake-jwt-token-12345',
        };
      } else {
        throw new Error('بيانات الدخول غير صحيحة');
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    isAuthenticated: false,
    loading: false,
    error: null,
    loginProgress: 0,
  },
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    updateLoginProgress: (state, action) => {
      state.loginProgress = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.loginProgress = 0;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        state.isAuthenticated = true;
        state.loginProgress = 100;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loginProgress = 0;
      });
  },
});

export const { logout, clearError, updateLoginProgress } = authSlice.actions;
export default authSlice.reducer;